// extracted by mini-css-extract-plugin
export var transition = "style-module--transition--18biT";
export var animate = "style-module--animate--2sNJM";
export var preAnimate = "style-module--preAnimate--3B9kp";
export var up = "style-module--up--3yxVh";
export var down = "style-module--down--3I_D9";
export var left = "style-module--left--3wY0a";
export var right = "style-module--right--3xH6G";